import script from "./ActionRender.vue?vue&type=script&lang=ts"
export * from "./ActionRender.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__